import {
  Control,
  Controller,
  FieldErrors,
  Path,
  RegisterOptions,
} from "react-hook-form";
import CustomInputV2 from "../CustomInputV2/CustomInputV2";

interface FormControlProps<T extends Record<string, any>> {
  name: Path<T>;
  label: string;
  placeholder: string;
  control: Control<T>;
  rules?: RegisterOptions<T>;
  errors: FieldErrors<T>;
}

const FormControl = <T extends Record<string, any>>(
  props: FormControlProps<T>
) => {
  const { control, name, errors, rules, label, placeholder, ...inputProps } =
    props;
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field }) => {
        return (
          <div className="flex flex-col w-full gap-1.5">
            {label && (
              <label htmlFor={name} className="font-medium text-xs">
                {label}
              </label>
            )}
            <CustomInputV2 {...field} placeholder={placeholder} />
            {errors[name] &&
              typeof errors[name] === "object" &&
              "message" in errors[name] &&
              typeof (errors[name] as any).message === "string" && (
                <span
                  className="text-red-500 text-xs font-medium"
                  role="alert"
                >{(errors[name] as any).message}</span>
              )}
          </div>
        );
      }}
    />
  );
};

export default FormControl;
